import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  groupSidebar: {
    padding: '3.2rem 2.4rem 0rem 3.2rem',
    color: colors.neutral[900],
  },
  groupInfoSection: { paddingBottom: '1.6rem', borderBottom: `1px solid ${colors.neutral[700]}` },
  groupTitle: { margin: { top: 0, bottom: '0.4rem' }, font: { weight: 700, size: '2rem', lineHeight: '2.8rem' } },
  viewProfileLink: {
    color: colors.blue[600],
    textTransform: 'uppercase',
    font: { weight: 500, size: '1.2rem', lineHeight: '2rem' },
    padding: 0,
    textDecoration: 'underline',
  },
  effectiveDateTitle: {
    margin: {
      top: '0.8rem',
    },
    font: {
      weight: 700,
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
  },
  addressTitle: {
    margin: 0,
    font: {
      weight: 700,
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
  },
  infoText: {
    margin: 0,
    font: {
      weight: 400,
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
    '&:first-of-type': {
      marginBottom: '0.8rem',
    },
  },
  milestones: { paddingTop: '2.4rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
